/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, HFlow, Icon } from 'bold-ui'
import { useState } from 'react'
import { useRouteMatch } from 'react-router'
import { useHistory } from 'react-router-dom'

import { ProntuarioCard } from '../soap/aside/ProntuarioCard'
import { AtendimentoIframe } from './SistemasExternosAtendimentoView'

interface SistemasExternosAtendimentoDetailProps {
  atendimentoIframe: AtendimentoIframe
}

interface UrlParams {
  iframeId: string
}

export function SistemasExternosAtendimentoDetail(props: Readonly<SistemasExternosAtendimentoDetailProps>) {
  const [iframeKey, setIframeKey] = useState(0)
  const history = useHistory()
  const match = useRouteMatch<UrlParams>()

  const iframeId = match.params.iframeId
  const parentUrl = match.url.replace(new RegExp(`/${iframeId}$`), '')
  const { nome, url } = props.atendimentoIframe

  const reloadIframe = () => {
    setIframeKey((prev) => prev + 1)
  }

  const renderTitle = () => (
    <HFlow hSpacing={0.5} alignItems='center'>
      <Button skin='ghost' size='small' onClick={() => history.push(parentUrl)} title='Voltar'>
        <Icon icon='angleLeft' size={1.2} />
      </Button>
      {nome}
    </HFlow>
  )

  const renderContent = () => (
    <Button size='small' skin='ghost' style={styles.reloadButton} onClick={reloadIframe}>
      <Icon icon='undo' />
    </Button>
  )

  return (
    <ProntuarioCard title={renderTitle()} content={renderContent()}>
      {<iframe key={iframeKey} css={styles.iframe} src={url} title={nome} referrerPolicy='strict-origin' />}
    </ProntuarioCard>
  )
}

const styles = {
  reloadButton: css`
    padding: 0rem 0.5rem;
  `,
  iframe: css`
    width: 100%;
    margin: 0rem;
    padding: 0rem;
    height: max(calc(100vh - 25rem), 68rem);
    border: none;
  `,
}
